import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-unit-option',
  templateUrl: './unit-option.component.html',
  styleUrls: ['./unit-option.component.scss'],
})
export class UnitOptionComponent {
  @Input() source: String | undefined;
  @Input() title: String | undefined;
  @Input() subTitle: String | undefined;

  constructor() {}
}
